import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { createImageUrl } from '../../../../../../../helper/Converters';
import { useState } from 'react';
import Toggle from '../../DnDSidebarItems/Inputs/Toggle';
function ComplementaryProduct_1({ item }) {
  const customization = staticComponentValueConverter(item?.customization);

  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;
  const image = createImageUrl(firstProduct?.variants?.[0]?.images?.[0]?.id);
  const [isActive, setIsActive] = useState(false);

  return (
    <div
      style={{
        margin: customization?.containerPadding,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: customization?.padding,
        gap: customization?.gap,
        backgroundColor: customization?.backgroundColor,
        borderRadius: customization?.borderRadius,
        borderWidth: 1,
        borderColor: customization?.borderColor,
        textAlign: 'left',
      }}
    >
      <div
        style={{
          fontSize: customization?.textSize,
          color: customization?.textColor,
          fontStyle: customization?.textStyle,
          fontWeight: customization?.textWeight,
        }}
      >
        Tamamlayıcı Ürün
      </div>

      <div
        style={{
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '12px',
            backgroundColor: '#F9F9F9',
            width: '100%',
          }}
        >
          <img
            src={image}
            alt="productImage"
            style={{
              width: '64px',
              height: '64px',
              objectFit: 'cover',
              borderRadius: '10px',
              marginRight: '12px',
            }}
          />
          <div style={{ flex: 1 }}>
            <div className="flex justify-between items-center">
              <div
                style={{
                  fontSize: customization?.ProductTextSize,
                  color: customization?.ProductTextColor,
                  fontStyle: customization?.ProductTextStyle,
                  fontWeight: customization?.ProductTextWeight,
                }}
                className="line-clamp-2"
                dangerouslySetInnerHTML={{ __html: firstProduct?.name || 'Ürün Başlığı' }}
              ></div>
              <div>
                <Toggle
                  setItem={value => {
                    setIsActive(value);
                  }}
                  value={isActive}
                  id={''}
                  targetKey={'abondonedCart'}
                  componentType={'toggle'}
                  hideBorder={true}
                  isWidgetItem={true}
                  className={'!p-1 display-flex justify-between'}
                  toggleClass={'!ml-[2px]'}
                ></Toggle>
              </div>
            </div>
            <div
              style={{
                backgroundColor: customization?.discountBackgroundColor,
                display: 'inline-block',
                padding: '2px 6px',
                borderRadius: customization?.discountBorderRadius,
                marginBottom: '6px',
                fontWeight: customization?.discountTextWeight,
                fontStyle: customization?.discountTextStyle,
                fontSize: customization?.discountTextSize,
                color: customization?.discountTextColor,
              }}
            >
              %5
            </div>
            <div>
              <span
                style={{
                  textDecoration: 'line-through',
                  fontSize: customization?.oldPriceTextSize,
                  color: customization?.oldPriceTextColor,
                  fontWeight: customization?.oldPriceTextWeight,
                  marginRight: '6px',
                }}
              >
                ₺299,99
              </span>
              <span
                style={{
                  fontSize: customization?.newPriceTextSize,
                  color: customization?.newPriceTextColor,
                  fontWeight: customization?.newPriceTextWeight,
                }}
              >
                ₺284,99
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-2">
        <div>
          <svg
            fill={customization?.informationTextColor}
            width="20px"
            height="20px"
            viewBox="-0.03 0 0.57 0.57"
            xmlns="http://www.w3.org/2000/svg"
            class="cf-icon-svg"
          >
            <path d="M0.493 0.287A0.238 0.238 0 1 1 0.255 0.05a0.238 0.238 0 0 1 0.238 0.238M0.175 0.099a0.205 0.205 0 1 0 0.08 -0.016 0.204 0.204 0 0 0 -0.08 0.016m0.08 0.04A0.034 0.034 0 1 1 0.221 0.173a0.034 0.034 0 0 1 0.034 -0.034zm0.024 0.277V0.26a0.024 0.024 0 1 0 -0.047 0v0.156a0.024 0.024 0 0 0 0.047 0" />
          </svg>
        </div>
        <div
          style={{
            fontSize: customization?.informationTextSize,
            color: customization?.informationTextColor,
            fontStyle: customization?.informationTextStyle,
            fontWeight: customization?.informationTextWeight,
          }}
        >
          {customization?.informationText}
        </div>
      </div>
      <div
        style={{
          fontSize: customization?.priceTextSize,
          color: customization?.priceTextColor,
          fontStyle: customization?.priceTextStyle,
          fontWeight: customization?.priceTextWeight,
        }}
      >
        {customization?.priceText}
      </div>
      <div
        style={{
          fontSize: customization?.priceSize,
          color: customization?.priceColor,
          fontStyle: customization?.priceStyle,
          fontWeight: customization?.priceWeight,
        }}
      >
        ₺ 799,99
      </div>
    </div>
  );
}

export default ComplementaryProduct_1;
